module.exports = __webpack_public_path__ + "img/diners_club.d64d6fad.jpg";